/**
 * Created by ganlu on 09/11/2016.
 */
class PageTitleService {
    constructor($window, $transitions,$translate) {
        "ngInject";
        this.$window = $window;
        this.$transitions = $transitions;
        this.$translate=$translate;
    }

    init() {

        let self = this;

        this.$transitions.onEnter({}, (transition, state) => {

            if (state.title) {
                self.$translate(state.title).then((translation) =>{
                    self.setTitle(translation);
                });

            } else {
                self.setTitle('');
            }
            if (state.description) {
                self.$translate(state.description).then((translation) =>{
                    self.setDescription(translation);
                });
            } else {
                self.$translate('page-default-desc').then((translation) =>{
                    self.setDescription(translation);
                });
            }
        });
    }

    setTitle(title) {
        let self=this;
        self.$translate('page-default-title').then((translation) =>{
            let str = translation;
            if (title) {
                str = title + " - " + str;
            }
            this.$window.document.title = str;
        });

    }

    setDescription(description) {
        $('meta[name=description]').attr('content', description);
    }
}

export default PageTitleService



// WEBPACK FOOTER //
// ./src/app/services/page-title.service.js